var dropdownSubTriggerIndicatorIcon = 'fx_2d2fb1e5_lw32sy0';

export { dropdownSubTriggerIndicatorIcon };
//# sourceMappingURL=subTriggerIndicator.vanilla.mjs.map
